















import Vue from 'vue';
import {Component, Prop} from "vue-property-decorator";
import {Icon} from "@/helpers/icons";
import Model from "@/models/Model";

@Component
export default class StateBar extends Vue {

	@Prop({type: Array, required: true})
	public states!: { text: string; value: any }[];

	@Prop({type: Object, required: true})
	public model!: Model;

	@Prop({type: String, required: true})
	public stateAttribute!: string;

	private icons = Icon;

	private get currentStateValue() {
		return (this.model as {[index: string]: any})[this.stateAttribute];
	}

	private get currentState(): { text: string; value: any } | null {
		return this.states.find(s => {
			return s.value === this.currentStateValue;
		}) ?? null;
	}

	private get currentStateIndex(): number {
		return this.currentState !== null ? this.stateIndex(this.currentState) : -1;
	}

	private stateIndex(state: { text: string; value: any }): number {
		return this.states.findIndex(s => {
			return s.value === state.value;
		});
	}

	private stateColor(state: { text: string; value: any }): string | null {
		if (state.value === this.currentStateValue) {
			return 'success';
		}

		if (this.isBeforeCurrentState(state)) {
			return 'success';
		} else {
			return null;
		}
	}

	private isBeforeCurrentState(state: { text: string; value: any }): boolean {
		return this.stateIndex(state) < this.currentStateIndex;
	}

	private isAfterCurrentState(state: { text: string; value: number }): boolean {
		return this.stateIndex(state) > this.currentStateIndex;
	}

}
